import { deDE as coreDeDE, enUS as coreEnUS } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';
import { deDE, enUS } from '@mui/x-data-grid/locales';

export default (locale: 'de' | 'en' | string | null | undefined) =>
  createTheme(
    {
      typography: {
        fontFamily: [
          'Twemoji Country Flags',
          '"Helvetica Neue"',
          'Helvetica',
          'Arial',
          'sans-serif'
        ].join(','),
        fontSize: 14
      },

      palette: {
        primary: {
          main: '#f39100',
          light: '#f391000b'
        },
        secondary: {
          main: '#6f6f6e'
        },
        success: {
          main: '#37B200',
          light: '#D3ffbf',
          dark: '#267d00',
          contrastText: '#ffffff'
        }
      },
      components: {
        MuiButton: { styleOverrides: { containedPrimary: { color: '#ffffff' } } }
        // MuiTextField: { defaultProps: { slotProps: { htmlInput: { style: { fontSize: 14 } } } } }
      }
    },
    locale === 'de' ? coreDeDE : coreEnUS,
    locale === 'de' ? deDE : enUS
  );
declare module '@mui/material/styles' {
  interface Palette {}
  interface PaletteOptions {}
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {}
}
